(function () {
  'use strict';

  function initializeFaq(root) {
    if (!root || root.dataset.faqInitialized === 'true') return;

    root.dataset.faqInitialized = 'true';
    root.classList.add('is-enhanced');

    var search = root.querySelector('[data-faq-search]');
    var searchForm = root.querySelector('[data-faq-search-form]');
    var clearButton = root.querySelector('[data-faq-search-clear]');
    var status = root.querySelector('[data-faq-status]');
    var emptyState = root.querySelector('[data-faq-empty]');
    var groupsContainer = root.querySelector('[data-faq-groups]');
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-faq-filter]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var activeCategory = 'all';

    function normalize(value) {
      return (value || '')
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        .trim();
    }

    function setActiveCategory(category) {
      activeCategory = category || 'all';
      filterButtons.forEach(function (candidate) {
        var isActive = candidate.dataset.faqFilter === activeCategory;
        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    items.forEach(function (item) {
      item.dataset.searchText = normalize(
        item.textContent + ' ' + (item.getAttribute('data-keywords') || '')
      );

      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var list = item.closest('.tesevo-faq__list');
        if (!list) return;
        Array.prototype.forEach.call(list.querySelectorAll('[data-faq-item][open]'), function (openItem) {
          if (openItem !== item) openItem.open = false;
        });
      });
    });

    function applyFilters() {
      var rawQuery = search ? search.value.trim() : '';
      var query = normalize(rawQuery);
      var queryTokens = query ? query.split(/\s+/).filter(Boolean) : [];
      var visibleCount = 0;

      items.forEach(function (item) {
        var categoryMatches = activeCategory === 'all' || item.dataset.category === activeCategory;
        var searchMatches = !queryTokens.length || queryTokens.every(function (token) {
          return item.dataset.searchText.indexOf(token) !== -1;
        });
        var visible = categoryMatches && searchMatches;

        item.hidden = !visible;
        if (!visible) item.open = false;
        if (visible) visibleCount += 1;
      });

      groups.forEach(function (group) {
        var hasVisibleItems = Array.prototype.some.call(
          group.querySelectorAll('[data-faq-item]'),
          function (item) { return !item.hidden; }
        );
        group.hidden = !hasVisibleItems;
      });

      if (clearButton) clearButton.hidden = !rawQuery;
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (groupsContainer) groupsContainer.hidden = visibleCount === 0;

      if (status) {
        if (rawQuery) {
          status.textContent = visibleCount + (visibleCount === 1 ? ' answer' : ' answers') + ' found for “' + rawQuery + '”.';
        } else if (activeCategory !== 'all') {
          var activeButton = root.querySelector('[data-faq-filter="' + activeCategory + '"] span');
          var topicName = activeButton ? activeButton.textContent : activeCategory;
          status.textContent = visibleCount + (visibleCount === 1 ? ' answer' : ' answers') + ' in ' + topicName + '.';
        } else {
          status.textContent = 'Browse all ' + visibleCount + ' frequently asked questions below.';
        }
      }
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setActiveCategory(button.dataset.faqFilter || 'all');
        applyFilters();
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        if (search.value.trim() && activeCategory !== 'all') setActiveCategory('all');
        applyFilters();
      });
      search.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && search.value) {
          search.value = '';
          applyFilters();
        }
      });
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    }

    if (clearButton && search) {
      clearButton.addEventListener('click', function () {
        search.value = '';
        applyFilters();
        search.focus();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!root.isConnected) return;
      var target = event.target;
      var isTyping = target && /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName);
      if (event.key === '/' && !isTyping && !event.metaKey && !event.ctrlKey && !event.altKey && search) {
        event.preventDefault();
        search.focus();
      }
    });

    var revealElements = Array.prototype.slice.call(root.querySelectorAll('[data-faq-reveal]'));
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealElements.forEach(function (element) { element.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -7% 0px',
        threshold: 0.08
      });

      revealElements.forEach(function (element) { observer.observe(element); });
    }

    applyFilters();
  }

  function initializeAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-tesevo-faq]')) initializeFaq(container);
    Array.prototype.forEach.call(container.querySelectorAll('[data-tesevo-faq]'), initializeFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
